// 近期热门 type=6

import mixin from './mixin'

export default {
  mixins: [mixin],

  render () {
    const {
      list, // from mixin
      title, // from mixin
      style, // from mixin
      onClick // from mixin
    } = this

    return (
      <section class={style.block}>
        <h2 class={style.title}>{title}</h2>
        <ul class={style.floatBox}>
          {
            list.map(item => (
              <li class={style.floatItem} onClick={() => onClick(item)}>
                <img class={style.img3} src={item.imageUrl} alt={item.title} />
              </li>
            ))
          }
        </ul>
      </section>
    )
  }
}
